<div style="background: #fff;">
	<div *ngIf="!user" class="container-fluid p-0 mi-portada" style="margin-top:56px;">
		<div class="col-8 offset-2 col-md-5 offset-md-1 p-5">
			<img src="./../../../assets/img/gestores_mx_logo.png" alt="" style="width: 100%;">
		</div>
	</div>

	<div *ngIf="user" class="container-fluid p-0 mi-portada-login" style="margin-top:56px;">
		<div class="col-8 offset-2 col-md-3 offset-md-1 p-5">
			<img src="./../../../assets/img/gestores_mx_logo.png" alt="" style="width: 100%;">
		</div>
	</div>


	

	<div class="container">

		<div class="row" *ngIf="user">
			<div class="col-12 p-3">
				
				<div class="alert alert-success mt-3">
					<p>
						Bienvenido {{ user.displayName }}
					</p>
	
					<p>
						Estas son tus estadísticas:
					</p>
	
					<ul>
						<li>
							Cantidad de registros: {{ cantidadRegistros }}
						</li>
	
						<li>
							Cantidad de verificados: {{ cantidadVerificados }}
						</li>
	
						<li>
							Porcentaje verificado: {{ (cantidadVerificados * 100) / cantidadRegistros }} %
						</li>
					</ul>
				</div>

			</div>
		</div>



		<div class="row" *ngIf="user">
			<div class="col-12 col-md-6 p-3 pt-5">
				<h3>Lista de top gestores por cantidad de registros</h3>
				<table class="table">
					<thead class="thead-dark">
						<tr>
							<th scope="col">Nombre</th>
							<th scope="col">Número de registros</th>
						</tr>
					</thead>

					<tr *ngFor="let item of mejoresGestores">
						<td class="text-left">{{ item.nombre_registrante }}</td>
						<td class="text-center">{{ item.numero_registros }}</td>
					</tr>
				</table>
			</div>

			<div class="col-12 col-md-6 p-3 pt-5">
				<h3>Lista de ultimos gestores registrados</h3>
				<table class="table">
					<thead class="thead-dark">
						<tr>
							<th scope="col">Nombre</th>
							<th scope="col">e-mail</th>
						</tr>
					</thead>

					<tr *ngFor="let item of ultimosGestores">
						<td class="text-left">{{ item.nombre }}</td>
						<td class="text-left">{{ item.email }}</td>
					</tr>
				</table>
			</div>
		</div>
	</div>
	
	<div class="container" *ngIf="!user">
		<div class="row mt-5">
			<div class="col-12 p-3 p-md-5 text-center">
				
				
				<button mat-raised-button color="accent" routerLink="/sesion-iniciar">
					<mat-icon matSuffix>login</mat-icon>
					Iniciar sesión
				</button>
				
			</div>
		</div>
	</div>


	<div class="container" *ngIf="user">
		<div class="row mt-5">
			<div class="col-12 p-3 p-md-5 text-center">
				<div class="row">
					<div class="col-12 col-md-6">
						<div style="display: block">
							<canvas baseChart
							[data]="doughnutChartData"
							[labels]="doughnutChartLabels"
							[chartType]="doughnutChartType">
							</canvas>
						</div>
					</div>

					<div class="col-12 col-md-6">
						<button mat-raised-button color="accent" routerLink="/form/capturar">
							<mat-icon matSuffix>app_registration</mat-icon>
							Capturar
						</button>
					</div>
				</div>
				
			</div>
		</div>
	</div>



	
	
</div>